import './css/App.css';
import React, { useEffect } from 'react';
import privateRoutes from './routes/private';
import publicRoutes from './routes/public';

import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import modernFlatTheme from './theme';

const router = createBrowserRouter([
  ...privateRoutes(),
  ...publicRoutes(),
  {
    path: "*",
    element: <Navigate to="/login" replace />,
  },
]);

function App() {
  useEffect(() => {
    document.title = 'datanomics';
  }, []);

  return (

  <React.StrictMode>
    <ThemeProvider theme={modernFlatTheme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>


  );
}

export default App;
